/**
 * Admin Portal Entry Point
 *
 * Authenticates against USERS Cognito pool (not CUSTOMERS).
 * Imports shared components from @portal.
 */

import { UnsupportedHost } from '@portal/components/shared/UnsupportedHost';
import { PORTAL_BRAND } from '@portal/config/branding';
import { AuthProvider } from '@portal/providers/AuthProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { applyBrandToDocument } from '../../../packages/ui/src/branding/host-brand';
import './index.css';

applyBrandToDocument(document, PORTAL_BRAND, 'admin');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {PORTAL_BRAND.id === 'neutral' ? <UnsupportedHost /> : <AuthProvider><App /></AuthProvider>}
    </BrowserRouter>
  </React.StrictMode>
);
